import React from 'react';
import CookieConsent from "react-cookie-consent";

const CookieBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All Cookies"
      declineButtonText="Keep Only Necessary Cookies"
      enableDeclineButton
      onAccept={() => {
        console.log("Cookies accepted");
        // Initialize Google Analytics and Facebook Pixel here
      }}
      onDecline={() => {
        console.log("Cookies declined");
        // Ensure analytics/marketing scripts are not loaded
      }}
      cookieName="coin_basis_cookie_consent"
      style={{ background: "#2B373B", color: "#fff" }}
      buttonStyle={{ background: "#4CAF50", color: "white", fontSize: "13px" }}
      declineButtonStyle={{ background: "#f44336", color: "white", fontSize: "13px" }}
      expires={365} // Set cookie expiry to 1 year
    >
      <p style={{ margin: 0 }}>
        Coin Basis uses cookies and similar tracking technologies, including Google Analytics and Facebook Pixel, to improve functionality, analyze usage, and optimize marketing. Read our
        <a href="/faq" style={{ color: "#4CAF50" }}> Privacy Policy</a> and
        <a href="/faq" style={{ color: "#4CAF50" }}> Cookies Policy</a> for more details.
      </p>
    </CookieConsent>
  );
};

export default CookieBanner;